(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-categories-menu"]) return;
  try {
                    
    $('.t4s-sub-menu .t4s-lazy_menu>div').remove();               

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
         
   var swiper = new Swiper(".collectionSwiper", {
       slidesPerView: 6,
       spaceBetween: 10,
       pagination: {
         el: ".swiper-pagination",
         clickable: true,
       },
       navigation: {
         nextEl: ".swiper-button-next",
         prevEl: ".swiper-button-prev",
       },
       breakpointsInverse: true,
       breakpoints: {
         360: {
           slidesPerView: 2,
         },         
         768: {
           slidesPerView: 3,
         },  
         992: {
           slidesPerView: 4,
         },
         1024: {
           slidesPerView: 5,
         },
         1200: {
           slidesPerView: 6,
         }        
        }
    });
        

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  $(function(){
      $('.see-more').click(function(){
          $('.page-description-info').toggleClass('page-description-show');
          if($('.page-description-info').hasClass('page-description-show')){
              $(this).text('see less');
          }else{
              $(this).text('see more'); 
          }
      })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
                    
    $('#select-ni-shipping').change(function() {
        selectWidth = $(this).find('option:selected').text().length * 8 + 50;
        $(this).css('width', selectWidth + 'px');
    });
    $("#select-ni-shipping").trigger("change");                  
    $(".icon-info").hover(function(){
        $(".product-customInformation__popup").toggleClass('hidden');
    });

  } catch(e) { console.error(e); }
})();
})();
